<div class="selected-offer"
     [ngClass]="{'selected-offer--next': isNext}"
     *ngIf="sectionVisible">
    <div class="selected-offer__logo-column">
      <span class="selected-offer__logo-column__label">{{ 'SELECTED_OFFER_COMPONENT.selectedOffer' | translate }}</span>
      <div class="selected-offer__logo-column__image">
        <img alt=""
             [src]="logoUrl">
      </div>
    </div>
    <div class="selected-offer__first-column">
        <div class="selected-offer__image">
          <img alt=""
            [src]="logoUrl">
        </div>
        <div class="selected-offer__box"
             [ngClass]="{'selected-offer__box--full-width': selectedOfferBoxFullWidth}">
          <ng-container *ngFor="let primaryBox of primaryBoxes">
            <app-offer-primary-box class="alt-offer__primary-coverages__coverage offer-primary-box"
                                    *ngIf="canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled)"
                                    [box]="primaryBox">
            </app-offer-primary-box>
          </ng-container>
        </div>
          <div class="selected-offer__price-container">
              <span class="selected-offer__your-price">{{'SELECTED_OFFER_COMPONENT.offerPrice' | translate}}</span>
              <div class="selected-offer__price">
                  <app-offer-price  [hasModifications]="hasModifications"
                                    [offer]="offer"
                                    [selectedPremium]="selectedPremium"
                                    [currentModificationsPrice]="offerModificationsService.offerCurrentPrice">
                  </app-offer-price>
              </div>
          </div>
    </div>
    <div *ngIf="!isNext"
         class="selected-offer__second-column">
        <ng-container *ngFor="let detailBox of detailBoxes">
            <div class="selected-offer__checkmark"
                 *ngIf="canShowBox(detailBox.options, detailBox.selectedOption, detailBox.enabled)">
              <app-offer-detail-box class="offer__info__ubezpieczenie--element span-child"
                                    [box]="detailBox">
              </app-offer-detail-box>
            </div>
        </ng-container>
    </div>
    <div *ngIf="isNext"
         class="selected-offer__details">
        <div class="selected-offer__details__detail-coverages">
            <div class="selected-offer__details__detail-coverages-group"
                 *ngFor="let group of detailCoverageGroupBoxes">
                <ng-container *ngFor="let box of group.boxes">
                    <app-next-offer-detail-box class="next-offer__detail-coverages__box"
                                               *ngIf="canShowBox(box.options, box.selectedOption, box.enabled)"
                                               [box]="box">
                    </app-next-offer-detail-box>
                </ng-container>
            </div>
        </div>
        <div class="selected-offer__details__details-btn">
            <button class="btn btn--clear"
                    (click)="openOffersPresentation()">
                {{'SELECTED_OFFER_COMPONENT.offerDetails' | translate}}
                <span class="material-icons">{{ offerDetailsBtnIcon }}</span>
            </button>
        </div>
    </div>
    <div *ngIf="!isNext"
         class="selected-offer__details-btn-row">
        <button class="btn btn--clear"
                (click)="openOffersPresentation()">
            {{'SELECTED_OFFER_COMPONENT.offerDetails' | translate}}
            <span class="material-icons">{{ offerDetailsBtnIcon }}</span>
        </button>
    </div>
    <div *ngIf="canShowChangePackageButton" class="selected-offer__third-column">
      <div class="selected-offer__change-package-container">
        <!--<span class="selected-offer__change-package">{{'SELECTED_OFFER_COMPONENT.changePackageInfo' | translate}}</span>-->
        <button (click)="backToOffers()" class="btn btn--tertiary">{{'SELECTED_OFFER_COMPONENT.changePackageButtonLabel' | translate}}</button>
      </div>
    </div>
  </div>
